import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { CompanyProfile } from '../titleAgent/components/companyProfile/companyProfile';

export const getVendorCompanyProfileRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    companyProfile: {
      path: `${basePath}/vendor-company-profile`,
      url: `${baseUrl}/vendor-company-profile`,
      documentTitle: 'Company Profile',
    },
  };
};

export const getVendorCompanyProfileRoutes = (basePath: string, baseUrl: string) => {
  const config = getVendorCompanyProfileRoutesConfig(basePath, baseUrl);
  console.log(config);
  return {
    companyProfile: (
      <Route exact path={config.companyProfile.path}>
        <Page routeDefinition={config.companyProfile}>
          <CompanyProfile />
        </Page>
      </Route>
    ),
  };
};
